module.exports = __webpack_public_path__ + "assets/dadesParser-min.2bc505d9eba20b94e9288c11c5266783.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Valeri/dadesParser-min.jpg
 ** module id = 411
 ** module chunks = 0
 **/